import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { icons } from '../../../constants'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import utils from '../../../utils'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Card } from 'primereact/card'
import { getInfoUnificarPessoa } from '../../../services/api-pessoa'

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function UnificarPessoaDialog(props) {
  const [selectedRecord, setSelectedRecord] = useState(undefined)
  const [dataset, setDataset] = useState([])

  const columns = [
    {
      field: 'multiselect',
      header: '',
      columnKey: 'multiselect',
      visible: true,
    },
    {
      field: 'oid',
      header: ' ',
      columnKey: 'oid',
      sortable: false,
      filter: false,
      columnSortField: 'oid',
      visible: true,
    },
  ]

  useEffect(() => {
    resetValues()
    fetchData()
  }, [props.visible])

  const fetchData = () => {
    const pessoas = _.get(props, 'pessoas', [])
    const oids = pessoas.map((pessoa) => pessoa.oid)
    if (!_.isEmpty(oids)) {
      getInfoUnificarPessoa(oids, props.pessoaFisica)
        .then((data) => setDataset(_.get(data, 'data', [])))
        .catch((err) => console.log(err))
    }
  }

  const isConfirmarDisabled = () => {
    return !selectedRecord
  }

  const onHide = () => {
    props.onHide()
  }

  const onConfirm = () => {
    const oidPessoaManter = _.get(selectedRecord, 'oid', null)
    const oidsPessoasRemover = dataset.filter((p) => p.oid !== oidPessoaManter).map((pessoa) => pessoa.oid)
    props.onConfirm(oidPessoaManter, oidsPessoasRemover)
    onHide()
  }

  const resetValues = () => {
    setSelectedRecord(undefined)
    setDataset([])
  }

  const formatColumn = (rowData) => {
    return (
      <React.Fragment>
        <Card>
          <div>
            <label>{`ID: ${rowData.id}`}</label>
          </div>
          <div>
            <label>{`ENDEREÇO: ${rowData.endereco1}`}</label>
          </div>
          <div>
            <label>{`CONTATO: ${rowData.contato}`}</label>
          </div>
        </Card>
      </React.Fragment>
    )
  }

  const getColumns = () => {
    return columns
      .filter((c) => c.visible)
      .map((col) => {
        if (col.field === 'multiselect') {
          return <Column selectionMode="single" style={{ width: '2.5em' }} />
        }
        return <Column {...col} key={col.field} body={formatColumn} />
      })
  }

  const onSelectionChange = (data) => {
    setSelectedRecord(data.value)
  }

  const resolveSubtitle = () => {
    return 'Selecione a pessoa que deve ser MANTIDA, as demais serão removidas. ATENÇÃO: Essa operação não poderá ser revertida.'
  }

  return (
    <Dialog
      header={utils.getMessage(props.messages, 'pessoafisica.label.unificar.pessoas')}
      visible={props.visible}
      style={{ width: '70vw' }}
      onHide={() => {
        onHide()
      }}
      baseZIndex={1000000}
      modal={true}
      closable={true}
    >
      <Card subTitle={resolveSubtitle()}>
        <div className="p-grid form-group">
          <div className="p-col-12">
            <DataTable
              value={dataset}
              selection={selectedRecord}
              onSelectionChange={onSelectionChange}
              emptyMessage=" "
              autoLayout={true}
            >
              {getColumns()}
            </DataTable>
          </div>
        </div>
      </Card>

      <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
        <Button
          label={_.defaultTo(props.labelConfirmar, 'Confirmar')}
          onClick={() => {
            onConfirm()
          }}
          disabled={isConfirmarDisabled()}
          icon={icons.CHECK_ICON}
          className="p-button-success"
        />
      </div>
    </Dialog>
  )
}
